var _path, _path2, _mask, _ellipse, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7273 2H9.72727C4.63636 2 2.45455 6.77193 2 9.15789V28.3947C2 33.4053 7.15152 35.5526 9.72727 36H29.7273C34.8182 34.9263 36.697 30.4825 37 28.3947V9.15789C36.2727 4.50526 31.8485 2.44737 29.7273 2Z",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8636 19.8946C26.8636 23.9853 23.4877 27.342 19.2727 27.342C15.0578 27.342 11.6818 23.9853 11.6818 19.8946C11.6818 15.804 15.0578 12.4473 19.2727 12.4473C23.4877 12.4473 26.8636 15.804 26.8636 19.8946Z",
    stroke: "black",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_72_620",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2727,
    cy: 10.0529,
    rx: 2.72727,
    ry: 2.68421
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2727,
    cy: 10.0529,
    rx: 2.72727,
    ry: 2.68421,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.0529C29 9.83362 29.1673 9.73707 29.2727 9.73707V15.7371C32.3906 15.7371 35 13.237 35 10.0529H29ZM29.2727 9.73707C29.3782 9.73707 29.5455 9.83362 29.5455 10.0529H23.5455C23.5455 13.237 26.1549 15.7371 29.2727 15.7371V9.73707ZM29.5455 10.0529C29.5455 10.2721 29.3782 10.3687 29.2727 10.3687V4.36865C26.1549 4.36865 23.5455 6.86873 23.5455 10.0529H29.5455ZM29.2727 10.3687C29.1673 10.3687 29 10.2721 29 10.0529H35C35 6.86873 32.3906 4.36865 29.2727 4.36865V10.3687Z",
    fill: "black",
    mask: "url(#path-3-inside-1_72_620)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgIcon);
export default __webpack_public_path__ + "static/media/IG_icon.fc517f84066b7f6db629441414e8d6d8.svg";
export { ForwardRef as ReactComponent };